import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
interface Props {
  isActive: boolean;
}

const NavbarMain = styled.div`
  max-width: 210px;
  width: 100%;
  position: relative;
  overflow: auto;
  background-color: var(--background-primary);
  ::-webkit-scrollbar {
    display: none;
  }
  ${mobile_xl(css`
    max-width: 100%;
    height: 100dvh;
    background-color: var(--background-secondary);
  `)}
`;

const BackButton = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 12px;
  padding: 3px 10px 3px 6px;
  gap: 6px;
  margin-left: 12px;
  cursor: pointer;
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    margin: 0;
  }
  .fill-color {
    path {
      fill: var(--text-secondary);
    }
  }
  &:hover {
    border-radius: 8px;
    background-color: var(--neutral-secondary);
    p {
      color: var(--text-primary);
    }
    .fill-color {
      path {
        fill: var(--text-primary);
      }
    }
  }
`;
const MenuSection = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${mobile_xl(css`
    margin-top: 0;
    padding-top: 4px;
    overflow: auto;
    gap: 6px;
    width: 100%;
  `)}
`;
const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${mobile_xl(css`
    padding: 0 12px;
  `)}
`;
const Title = styled.div`
  display: flex;
  align-items: center;
  ${Typography.body_md_medium}
  padding: 0 18px;
  p {
    margin: 0;
    color: var(--text-secondary);
  }
  .stop-color {
    stop {
      stop-color: var(--neutral-primary);
    }
  }
  ${mobile_xl(css`
    display: none;
  `)}
`;
const Submenu = styled.div<Props>`
  padding: 5px 8px 5px 6px;
  ${Typography.body_md_medium}
  color: var(--text-primary);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  ${({ isActive }) =>
    !isActive &&
    css`
      :hover {
        background: var(--neutral-secondary);
      }
    `}
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--background-muted);
    `}
    ${mobile_xl(css`
    padding: 11px 12px 11px 8px;
    gap: 8px;
    /* for help and support icon */
    svg {
      margin: 0;
    }
    :hover {
      background-color: transparent;
    }
    .reference-item {
      padding-inline: 0;
    }
    .dropdown-item {
      padding: 0;
      :hover {
        background-color: unset;
      }
      p {
        font-weight: 500;
      }
    }
  `)};
`;

const ProfileMenu = styled.div`
  padding: 11px 12px 11px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const LHS = styled.div`
  p {
    width: 145px;
    margin: 0;
    ${Typography.body_xl_medium}
    color: var(--text-primary)
  }
  &.log-out {
    p {
      color: var(--accent-error);
    }
  }
`;

const RHS = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  p {
    width: 100%;
    margin: 0;
    ${Typography.body_md}
    color: var(--text-secondary);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    word-break: break-all;
  }
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconView = styled.div`
  position: absolute;
  left: -2px;
  ${mobile_xl(css`
    left: 0;
  `)}
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 12px;
  &.bottom-div {
    margin-bottom: 24px;
    ${mobile_xl(css`
      margin-bottom: 70px;
      padding: 0;
    `)}
  }
  ${mobile_xl(css`
    gap: 4px;
    padding: 0;
  `)}
`;

const TitleBorder = styled.div`
  width: 100%;
  border-bottom: 0.5px solid var(--neutral-primary);
`;

const Line = styled.div`
  display: none;
  ${mobile_xl(css`
    display: block;
    border-bottom: 0.5px solid var(--border-primary);
  `)}
`;

const Icon = styled.div`
  display: flex;
  ${mobile_xl(css`
    .svg-icon {
      width: 20px;
      height: 20px;
    }
    .logout-icon {
      path {
        stroke: var(--accent-error);
      }
    }
  `)}
`;

const LogoutMenu = styled.div`
  padding: 11px 12px 11px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export {
  NavbarMain,
  BackButton,
  Menu,
  Title,
  Submenu,
  IconView,
  Div,
  TitleBorder,
  MenuSection,
  Line,
  ProfileMenu,
  LHS,
  RHS,
  IconDiv,
  Icon,
  LogoutMenu,
  IconWrapper
};
